import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  MdOutlineSos,
  MdOutlineConstruction,
  MdOutlinePayments,
} from "react-icons/md";
import { TbBuildingCottage } from "react-icons/tb";
import { FiUsers, FiSettings } from "react-icons/fi";
import { IoMdPerson } from "react-icons/io";
import { TbReport } from "react-icons/tb";
import { IoPeople } from "react-icons/io5";

function AdminQuickAccessMobile() {
  const currentUser = useSelector((state) => state.userObject);

  const apps = [
    {
      appName: "SOS",
      roles: ["super-admin", "admin", "all"],
      icon: <MdOutlineSos size={24} />,
      path: "/admin/mobile/sos",
    },
    {
      appName: "Condo Corp",
      roles: ["super-admin", "admin", "all"],
      icon: <TbBuildingCottage size={24} />,
      path: "/admin/mobile/condo-corp",
    },
    {
      appName: "Resident List",
      roles: ["super-admin", "admin", "reception", "security"],
      icon: <IoPeople size={24} />,
      path: "/admin/mobile/residents",
    },
    {
      appName: "Suppliers",
      roles: [
        "super-admin",
        "admin",
        "engineering",
        "maintenance",
        "security",
        "reception",
        "admin",
        "super-admin",
        "finance",
        "board",
      ],
      icon: <MdOutlineConstruction size={24} />,
      path: "/admin/mobile/suppliers",
    },
  ];

  // Filter apps based on user role
  const filteredApps = apps.filter(
    (app) =>
      app.roles.includes("all") ||
      currentUser?.roles?.some((role) => app.roles.includes(role))
  );

  return (
    <div className="bg-white rounded-xl shadow-sm px-4 py-5 mt-2">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-semibold text-[#363062]">Quick Access</h2>
      </div>
      <div className="grid grid-cols-4 gap-4">
        {filteredApps.map((app, index) => (
          <Link
            key={index}
            to={app.path}
            className="flex flex-col items-center cursor-pointer transition-transform active:scale-95 h-18"
          >
            <div className="text-4xl text-eleghoBlue mb-1">{app.icon}</div>
            <span className="text-[10px] font-medium text-center text-gray-700 mt-1">
              {app.appName}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default AdminQuickAccessMobile;
